module.exports = __webpack_public_path__ + "img/img_a@2x.595984a3.png";